module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('h1', {
    staticClass: "h1"
  }, [_c('span', {
    attrs: {
      "aria-label": "page iv",
      "epub:type": "pagebreak",
      "id": "page_iv",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "page v",
      "epub:type": "pagebreak",
      "id": "page_v",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "page vi",
      "epub:type": "pagebreak",
      "id": "page_vi",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "page 1",
      "epub:type": "pagebreak",
      "id": "page_1",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("THE ZODIAC KILLER "), _c('span', {
    staticClass: "heading_break"
  }, [_vm._v("A CONTROL FREAK PUTS ON A HOOD")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The press loves to put terror in a box and give it an eye-grabbing label. As a result, most serial killers get their monikers from the media. The Mad Butcher of Kingsbury Run? The press. The Night Stalker? Reportedly the since-shuttered "), _c('i', [_vm._v("Los Angeles Herald Examiner")]), _vm._v(". The Hillside Strangler? Enterprising reporters. The Green River Killer? Coined by the press after his first five victims were found in the Green River. I never said any of these were particularly clever.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Where the nickname game gets really interesting is when the murderers give themselves a new name. While Dennis Rader was strangling women and sometimes their families in the Wichita, Kansas, area, he found time to drop notes. The first he left in a public library book that read, “The code words for me will be bind them, torture them, kill them, B.T.K.” The note found its way to the local newspaper and the media, and Rader in subsequent notes would sign off with “B.T.K.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-001",
      "id": "endnote-001-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" Postal employee "), _c('span', {
    attrs: {
      "aria-label": "page 2",
      "epub:type": "pagebreak",
      "id": "page_2",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("David Berkowitz caused hundreds of women in New York City to cut their long brown hair and dye it blonde out of fear they’d be his next victim. At the scene of one of his crimes, he left a note calling himself “Son of Sam.” Apparently a demonically possessed dog owned by a guy named Sam put him up to the whole thing. Score one for cat people everywhere.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The nicknames of these killers are significant.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("According to one of the founding fathers of criminal profiling, John Douglas, it’s part of the overall goal many of these killers strive for—to create their own legend."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-002",
      "id": "endnote-002-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" The ones that create their own names go further. It’s an effort to completely control their narrative. They don’t trust society to get it right. They don’t believe the press will adequately convey their genius and majesty. They want a tight grip on the reins of their legacy and narrative.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Control is something the Zodiac could teach a master class in.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“This is the Zodiac speaking” is the first sentence in a three-page letter to the "), _c('i', [_vm._v("San Francisco Chronicle")]), _vm._v(" sent by the notorious killer. It was the second of many letters he would send. Right from the start, the Zodiac was demanding the press (and everyone else) address him in a certain way. He was demanding their attention and their submission.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Zodiac was a control freak.")]), _vm._v(" "), _c('hr', {
    staticClass: "secbreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Bettye Harden didn’t cook dinner one night in early August of 1969. In many modern households, this would be the furthest thing from a shock. But while 1969 wasn’t exactly "), _c('i', [_vm._v("Leave It to Beaver")]), _vm._v(" times, there were still remnants of these sorts of "), _c('span', {
    attrs: {
      "aria-label": "page 3",
      "epub:type": "pagebreak",
      "id": "page_3",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("traditions, and an empty table was a sign of trouble. And there was trouble. Trouble that Bettye and her husband were trying to help by solving a puzzle instead of concentrating on dinner."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-003",
      "id": "endnote-003-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Portions of a 408-character cipher had been sent to three newspapers about a week earlier. The cipher portions, sent to the "), _c('i', [_vm._v("Vallejo Times-Herald,")]), _vm._v(" the "), _c('i', [_vm._v("San Francisco Chronicle,")]), _vm._v(" and the "), _c('i', [_vm._v("San Francisco Examiner")]), _vm._v(" each included a similar letter. The "), _c('i', [_vm._v("Chronicle’s")]), _vm._v(" version read:")]), _vm._v(" "), _c('div', {
    staticClass: "inline_group"
  }, [_c('img', {
    staticClass: "portrait_50",
    attrs: {
      "alt": "Image",
      "src": "e9781646041145/images/f0003-01.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inline_group"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 4",
      "epub:type": "pagebreak",
      "id": "page_4",
      "role": "doc-pagebreak"
    }
  }, [_c('img', {
    staticClass: "portrait_50",
    attrs: {
      "alt": "Image",
      "src": "e9781646041145/images/f0004-01.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "inline_group"
  }, [_c('img', {
    staticClass: "landscape_50",
    attrs: {
      "alt": "Image",
      "src": "e9781646041145/images/f0004-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Every letter ended not with a name, but with a symbol. A circle with a cross running through it like crosshairs, the symbol that has now become synonymous with the name the author would give himself in his next letter: Zodiac.")]), _vm._v(" "), _c('hr', {
    staticClass: "secbreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 5",
      "epub:type": "pagebreak",
      "id": "page_5",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("The stories of the murders the Zodiac alludes to in his letters have been told too many times to count. On podcasts, in books, in documentaries, and likely around campfires and during law enforcement trainings alike. So let’s try to think of them in a different way: Let’s put the victims first. Let’s remember that they were real flesh and blood people who never expected that the nights they died would be their last nights. Let’s think of them as people who loved and were loved. Let’s keep in mind the absolute terror they must have felt when they died helpless and terrified.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The first murder the Zodiac referenced, though many speculate that he’s responsible for others before this one, involved a teenage couple out on a date. A very strange supplemental police report by Solano County Sheriff’s Department Detective Sergeant Les Lundblad read, “Victims’ activity at time offense: INTERRUPTED NECKING.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-004",
      "id": "endnote-004-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("David Faraday was a seventeen-year-old transplant to Vallejo from San Rafael, California. At the time of his death, he was a senior in high school, a member of school government, and on the wrestling team. He was even a damn Eagle Scout,"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-005",
      "id": "endnote-005-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" the highest of Boy Scouts, and in the late ’60s, that mattered. Even today, only a small percentage of scouts make it to that level. You have to get twenty-one merit badges—including cooking."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-006",
      "id": "endnote-006-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" You also have to put together a big project and hold a leadership post for six months. It wasn’t like "), _c('i', [_vm._v("my")]), _vm._v(" scout troop where you showed up to one meeting, sold a few boxes of cookies, and still somehow got enough badges to move on to the next level. David likely had to go into the woods and start a fire with wet matches or fight a grizzly bear or something else equally impressive and difficult.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 6",
      "epub:type": "pagebreak",
      "id": "page_6",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Eagle Scout David’s girlfriend was Betty Lou Jensen, a sixteen-year-old and a junior at Hogan High School. She was an honor student and member of an organization called the Sunshine Girls, a lower order of the Pythian Sisters. Their motto is, “Do all the good you can in all the ways you can, to all the people you can.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-007",
      "id": "endnote-007-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It makes sense that when these two kids met each other, they clicked. They set out on their first “official” date together on December 20, 1968.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Betty Lou probably tried on multiple outfits, her bed overtaken with rejected dresses, skirts, and sweaters. She probably tried a couple new shades of lipstick and talked at length to her friends about the cute, smart jock with the full lips and a wide smile who finally asked her out.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As for David, he probably went about his school day with an extra lift in his step. The girl with the button nose and cute cheeks from the other side of town that he’d been thinking about said “yes,” and he had a great night planned.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("According to friends and family who later spoke to police, David picked up Betty Lou in his mother’s car at around 8:30 p.m. They told Betty Lou’s parents they were going to a Christmas concert. They promised to be home by 11:00 p.m. Then Betty Lou said goodbye to her parents."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-008",
      "id": "endnote-008-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" They never saw her alive again.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The couple didn’t go to the Christmas concert. They went to see a friend and then they stopped for a Coke before heading to Lake Herman Road. This area was known as a “lovers’ lane.” In the days before young couples would make out and break up in public with abandon, teens would go to secluded areas "), _c('span', {
    attrs: {
      "aria-label": "page 7",
      "epub:type": "pagebreak",
      "id": "page_7",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("and park their cars to talk, get to know each other, and—you know. They parked on a gravel strip just off the road, isolated, but near a gas station. David left the car’s ignition on, likely to keep the pair warm while they sat together in the chilly night.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A mother on her way to Lake Herman Road to pick up her own son found their bodies.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Betty Lou was shot five times in the back. She’d tried to run away, the dark unknown safer than what was behind her, but she didn’t get far. Betty Lou’s body lay about thirty feet from the back of the car. When the mother arrived, David was still breathing, on the ground outside the car, lying in a pool of his own blood with the passenger door of the car open. His feet were sprawled toward the rear wheel.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Bullet holes were found in the rear window and roof of the car. Law enforcement believe the Zodiac was attempting to herd David and Betty Lou out through the opened passenger door in order to keep the terrified kids from scattering. His shots were sure, without a spray of excess bullets. Everything was carefully planned and carried out. He had total control over the situation."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-009",
      "id": "endnote-009-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("We’d see more evidence of this extreme confidence at his next crime scene. After all, he was just getting warmed up. About six months after the Zodiac gunned down David and Betty Lou, he struck again.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Darlene Ferrin was a vivacious blonde who was so petite, she looked like you could pick her up and throw her over your shoulder without breaking a sweat. She liked to flirt and had married a nice man who didn’t seem to mind that she would "), _c('span', {
    attrs: {
      "aria-label": "page 8",
      "epub:type": "pagebreak",
      "id": "page_8",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("sometimes spend time with other men. She was twenty-two on the Fourth of July in 1969, and she lived in Vallejo with her husband Dean and their baby girl.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Darlene wanted to meet up with Mike Mageau that Fourth of July night. Mike was a slight guy who would wear multiple layers of clothes to make himself appear larger. It was a practice that initially bewildered the police after the attack and, frankly, it really tells you a lot about his personality. We all know a guy like this. A little self-conscious, probably gets into scraps when he knows he shouldn’t, just to prove himself."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-010",
      "id": "endnote-010-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" Mike had previously been arrested for “petty theft” at a local store the year before."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-011",
      "id": "endnote-011-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" He initially gave police a fake name, but copped to it when his real ID was discovered. But ultimately, he was harmless. For kids of the ’90s: In the 2007 David Fincher film "), _c('i', [_vm._v("Zodiac")]), _vm._v(", Mike was played by Lee Norris, a.k.a. Minkus from "), _c('i', [_vm._v("Boy Meets World,")]), _vm._v(" if that helps you with a visual.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There are several versions of what happened between the time when Mike got in the car and the Zodiac approached their vehicle at Blue Rock Springs Park. Some say that they were going to get fireworks and that the Zodiac’s car started following them while they were driving—they tried to lose the car and ended up at the park. But an interview between a groggy, drugged, and likely still terrified Mike and Vallejo police detective Ed Rust painted a different picture."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-012",
      "id": "endnote-012-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" Mike said they originally planned to go to a movie at around 7:30 p.m. that night, but the plans kept getting pushed back until 11:30 p.m. when Darlene finally picked him up. They were hungry and going to get something to eat, but then Darlene said she wanted to talk to Mike about something. So, Mike suggested "), _c('span', {
    attrs: {
      "aria-label": "page 9",
      "epub:type": "pagebreak",
      "id": "page_9",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("they go to Blue Rock Springs Park, where they were attacked soon after they arrived."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-013",
      "id": "endnote-013-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When Vallejo police showed up on the scene, the headlights, taillights, and left blinker of Darlene’s car were still on. The ignition was turned off, and the transmission was in first gear. The radio was playing.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Mike was still alive, lying on his back on the ground. He’d been shot multiple times, had blood all over his face, was bleeding from the mouth, and had another wound visible on his lower left leg.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Officers tried to get some information out of Mike, even as he was lying there in the dirt, the pain like nothing he’d ever known. The first few minutes and hours are crucial in an investigation, and they had a suspect on the loose. So an officer kept asking for something, anything, to help them figure out what happened and who did it.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Under the red and blue lights of the police car in the dark night, Mike was able to tell them only a few things.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It was a white male—young, heavyset.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("He was in a brown vehicle.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("He didn’t say anything, “He just started shooting and kept shooting.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-014",
      "id": "endnote-014-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Darlene was still in the car, in the driver’s seat with three bullet holes, her body slumped, her head resting against the window. Darlene and Mike were taken to the hospital. Mike went to the ICU, where they took off three pairs of pants, one T-shirt, three sweaters, and one long-sleeved button-down shirt."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-015",
      "id": "endnote-015-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 10",
      "epub:type": "pagebreak",
      "id": "page_10",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Darlene was dead on arrival.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Mike would later tell police that the Zodiac had "), _c('i', [_vm._v("walked away")]), _vm._v(". He fired off half a dozen shots into a stalled vehicle, the lights from the muzzle flash breaking the nighttime darkness in quick bursts. He fired the gun, believing he had just killed two young people—a boy and a girl—and then he just walked to his car and drove away."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-016",
      "id": "endnote-016-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("But he wasn’t done for the night. He drove to a pay phone and called the police to say, “I want to report a double murder.” The caller then said where police could find the “kids in a brown car” that he had shot. He ended with, “I also killed those kids last year. Goodbye.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-017",
      "id": "endnote-017-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("According to the 911 dispatcher Nancy Slover’s report, the caller sounded like he was reading or had practiced what he was going to say. Her report stated: “spoke in an even, consistent voice (rather soft but forceful).” Nancy finished saying, “Subject’s voice was mature. The only real change in the voice was when he said ‘goodbye.’ Subject’s voice deepened and became taunting.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-018",
      "id": "endnote-018-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I’ll bet poor Nancy had nightmares for months on the minimum after that call.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("He planned every movement, minute, and syllable. He was ready. He was prepared. And after this round of mayhem he decided to throw a few extra logs on the fire he was stoking throughout California. The Zodiac decided he was ready for prime time.")]), _vm._v(" "), _c('hr', {
    staticClass: "secbreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 11",
      "epub:type": "pagebreak",
      "id": "page_11",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("This brings us back to Bettye Harden, her uncooked dinner, and the puzzle on her kitchen table that she was trying to solve. The cipher was in three parts: one part sent to the "), _c('i', [_vm._v("San Francisco Chronicle")]), _vm._v(", another to the "), _c('i', [_vm._v("San Francisco Examiner,")]), _vm._v(" and another to the "), _c('i', [_vm._v("Vallejo Times-Herald")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In later retellings of what happened, her husband Donald, a schoolteacher at North Salinas High School, usually gets first billing and most of the credit for resolving the cipher. The "), _c('i', [_vm._v("Orlando Sentinel")]), _vm._v(" ran a front-page piece on the cipher titled, “Former Orlandoan Cracked Zodiac Code.” The singular is an obvious reference to Donald alone, especially given that his picture is in the paper with the caption “DONALD HARDEN…Cracked ‘Zodiac’ code.” Bettye is listed as “his wife,” and they didn’t even spell her name right."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-019",
      "id": "endnote-019-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("But it was Bettye with the two t’s and two e’s who discovered the crucial clues necessary to decode a cipher that the FBI and other guys who are usually the smartest men in the room couldn’t solve. Looking at a puzzle that used symbols from astrology, Asian mythology, Greek letters, and more, she thought of the tools that could be used to make sense of the hodgepodge. Bettye’s the one who realized a serial killer was bound to use the word “kill” or “killing” more times than most other words in his puzzle. Bettye also guessed that the letter would begin with “I” since he was an obvious egomaniac. Right on both counts, Bettye and Donald used those valuable tools, sometimes called “cribs,” to unlock other letters and words throughout the puzzle. They solved it within a week."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-020",
      "id": "endnote-020-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "blockl"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 12",
      "epub:type": "pagebreak",
      "id": "page_12",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("I like killing people because it is so much fun it is more fun than killing wild game in the forrest because man is the most dangeroue anamal of all to kill something gives me the most thrilling experence it is even better than getting your rocks off with a girl the best part of it is thae when I die I will be reborn in paradice and thei have killed will become my slaves I will not give you my name because you will try to sloi down or atop my collectiog of slaves for afterlife"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-021",
      "id": "endnote-021-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This is the only cipher that would ever be considered solved, though the Zodiac would send more, and even this cipher wasn’t fully cracked. There was a string of symbols at the very end which, when decoded by the Hardens, read EBEO RIET EMETH HPITI."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-022",
      "id": "endnote-022-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" These jumbled letters have fascinated and bewildered puzzle lovers for decades. To this day, people post in Facebook groups and online forums that they believe they have cracked the final words of the puzzle. But there has yet to be any definitive answer.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Until this point, there had been no apparent connection between David Faraday and Betty Lou Jensen’s murders and the attack on Mike Mageau and Darlene Ferrin. Without the Zodiac demanding attention and credit, it’s possible the link never would have been realized given the different law enforcement departments. While under normal circumstances the deaths of three people and injury of one person wouldn’t mean much to a city of thousands, let alone the nation, those letters and that cipher did exactly what the Zodiac wanted—made him a household name and began to bring entire cities under his thumb.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 13",
      "epub:type": "pagebreak",
      "id": "page_13",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("The Zodiac wasn’t finished sending letters or murdering people. What might be his most infamous killing of all was next.")])]), _vm._v(" "), _c('hr', {
    staticClass: "secbreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cecelia Ann Shepard and Bryan Hartnell just wanted to have a picnic.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It was Saturday, September 27, 1969. Cecelia and Bryan were old friends. They had dated two years before the attack but ended up going to different colleges. Cecelia was in Bryan’s neck of the woods visiting friends when they met up at his school cafeteria. They decided to spend the rest of the day together. Initial plans to go to San Francisco fell through because they had to run errands and play chauffeur to other people, and it got too late in the day. Instead, they went to Lake Berryessa, parked by the road, and walked down a peninsula to be by the water.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The scene was romantic. Two people who’d lost touch over the years started to rekindle a flame by the water on a warm evening. They talked about old times. She rested her head on his shoulder. But then Bryan heard a rustle of leaves and Cecelia saw a figure in the distance. The figure stepped behind a tree and when he came back, Cecelia grabbed Bryan’s arm. “Oh my God, he’s got a gun!”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-023",
      "id": "endnote-023-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Everything the figure was wearing was either black or dark blue. Old suit pants, a windbreaker, a shirt underneath, and a hood. Bryan described the hood as “ingeniously devised.” It was black and looked like a paper sack, with four corners at the top, and it came down with a panel of fabric covering "), _c('span', {
    attrs: {
      "aria-label": "page 14",
      "epub:type": "pagebreak",
      "id": "page_14",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("his chest and a similar panel down his back. The fabric had a circle with a cross in the middle: the sign of the Zodiac."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-024",
      "id": "endnote-024-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The best account we have of what happened came from Bryan. On September 28, 1969, while still heavily sedated and in the Queen of the Valley Hospital, he answered Napa County Sheriff’s Department Detective Sergeant John Robertson’s questions. He told police that because of his school background in sociology and the fact that he had taken both prelaw and psychology classes, he felt he knew enough about the criminal mind to turn this situation into something that would be an amusing anecdote later on. Maybe he thought he could impress Cecelia with his bravery. But he didn’t know he was in front of the Zodiac. He didn’t know that the intention was to kill. He thought it was just a robbery."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-025",
      "id": "endnote-025-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Bryan told the man who had come through the trees that he didn’t have any money—only fifty cents—but he offered to help in any way he could. The man refused and said he was on the run, just released from prison. The man had Cecelia tie up Bryan. At this point, Bryan said he thought he could get the gun that was pointed at them, but Cecelia looked too afraid, and Bryan said he decided against it. Then the man tied up Cecelia, checked Bryan’s restraints, and hog-tied both of them, stringing rope between their wrists and ankles, positioning them with their stomachs on the ground. Bryan still thought they would be okay. He was more worried about them freezing if the figure left them tied up.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("But he didn’t leave them to freeze. Instead he stabbed them both repeatedly in their torsos. Then he left. Bryan, convinced there was no way either of them could survive, but still determined to "), _c('span', {
    attrs: {
      "aria-label": "page 15",
      "epub:type": "pagebreak",
      "id": "page_15",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("give it his best shot, kissed Cecelia and told her he was going to try to get help. Bryan dragged his body up to the road where assistance eventually came. Bryan survived, but Cecelia did not. After the attack, Bryan told the police of the spot:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“There was this one place I used to go out…we used to all the time, you know…and I couldn’t find it. And so I figured ‘Ah, forget it, and this looks like as good a place as any.’ ”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-026",
      "id": "endnote-026-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("He picked the spot. That’s the sort of survivor’s guilt that’s almost impossible to shake.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("At the time that Bryan was talking to law enforcement, he didn’t realize that the Zodiac had attacked him and murdered Cecelia. But the killer made it clear that the scene at Lake Berryessa was his handiwork. He wrote on the door of Bryan’s white Volkswagen:")]), _vm._v(" "), _c('blockquote', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "blocklt"
  }, [_vm._v("Vallejo")]), _vm._v(" "), _c('p', {
    staticClass: "blocklt"
  }, [_vm._v("12-20-68")]), _vm._v(" "), _c('p', {
    staticClass: "blocklt"
  }, [_vm._v("7-4-69")]), _vm._v(" "), _c('p', {
    staticClass: "blocklt"
  }, [_vm._v("Sept 27-69-6:30")]), _vm._v(" "), _c('p', {
    staticClass: "blocklt"
  }, [_vm._v("by knife")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Then, just to be sure everyone knew who they were dealing with, the Zodiac called the police.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“I want to report a murder—no, a double murder. They are two miles north of park headquarters. They were in a white Volkswagen Karmann Ghia.” His voice growing distant, the Zodiac ended the call saying, “I’m the one who did it.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-027",
      "id": "endnote-027-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 16",
      "epub:type": "pagebreak",
      "id": "page_16",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Bryan’s recollection of events led to a now-infamous sketch of the Zodiac, a hefty man wearing a black hood with blank holes where eyes should be."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-028",
      "id": "endnote-028-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As with David Faraday, Betty Lou Jensen, Darlene Ferrin, and Mike Mageau, the attack on Cecelia Ann Shepard and Bryan Hartnell would go without an arrest. The only comforting thing in retrospect is that it was almost over. Though there was no way to know it at the time, the final murder that would be tied to the Zodiac was right around the corner. But now, the Zodiac decided to break all of his old patterns.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On October 11, 1969, the Zodiac murdered twenty-nine-year-old San Francisco cabdriver Paul Stine."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-029",
      "id": "endnote-029-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" It wasn’t a couple out canoodling in the park or in a car. There were no elaborate costumes that we know of, no attempts to set a scene. It wasn’t the long, drawn-out type of killing with a knife. It was one victim, killed with one shot while trying to earn his daily living.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Around 9:55 p.m. on that Saturday, Stine picked up a passenger at an intersection in San Francisco, not knowing the man was the Zodiac. Stine drove to Washington and Cherry Street, and when he stopped, the Zodiac shot Stine behind his right ear with a 9 mm semiautomatic. The Zodiac took his wallet, the keys to the cab, tore off a piece of Stine’s shirt, and then he disappeared.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This final known murder would not have been attributed to the Zodiac if he hadn’t made sure the police knew it was him. It was outside of his usual method of operations, hurried and unsophisticated. No one initially suspected that this was a Zodiac murder. They thought it was just another cabdriver killing done for a few bucks in fares. But then, two days after the murder, "), _c('span', {
    attrs: {
      "aria-label": "page 17",
      "epub:type": "pagebreak",
      "id": "page_17",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("the "), _c('i', [_vm._v("San Francisco Chronicle")]), _vm._v(" got a present in the mail: the torn piece of Stine’s bloody shirt, along with a letter that threatened to shoot a bus full of children, saying, “School children make nice targets.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-030",
      "id": "endnote-030-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" It mocked police for not catching him.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Some witnesses did see the Zodiac that night without any sort of hood or costume on. They said he wiped down the inside of the cab and then calmly walked away. They described him as a white male, thirty-five to forty-five years old. Witnesses said he was about five feet ten inches, 190 pounds, with reddish-blonde hair worn in a crew cut. They said he wore glasses with plastic frames and a navy or black parka-like jacket. Possibly the same jacket he wore at the Lake Berryessa murder. The witnesses also said he had a paunchy stomach.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("From these witnesses’ descriptions, a sketch of the Zodiac unmasked was created, and since then people have used it to claim everyone from their own father to Senator Ted Cruz is the Zodiac. But let’s stick with the description for a minute. It makes sense: paunchy, glasses, wearing baggy clothes. The Zodiac sounds like any background loser in a movie. Maybe that’s where his psychosis stemmed from. Maybe this guy had been a reject his entire life. Socially awkward, with no real control over anything happening to him, especially over how people saw him or interacted with him. And while we’re engaging in amateur-level psychology, doesn’t it make sense that someone with no control over his personal environment and physical presentation would be so controlling over his murders? That someone who craved attention his whole life, because he didn’t get it in the “normal” world, would then play cat-and-mouse games with police and reporters? He never had control, until he started killing. That’s when the Zodiac was able to exert the "), _c('span', {
    attrs: {
      "aria-label": "page 18",
      "epub:type": "pagebreak",
      "id": "page_18",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("most control in his life, not just over his victims, but also over the public and over the press. Yet, there was always one reporter he couldn’t quite dominate.")])]), _vm._v(" "), _c('hr', {
    staticClass: "secbreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Paul Avery was a classic example of a journalist getting too close to his subject, but his work was indisputably impressive.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Avery was a longtime crime reporter for the "), _c('i', [_vm._v("San Francisco Chronicle")]), _vm._v(" when the Zodiac sent his first letter to their outlet, demanding its publication. He jumped on the story, wrote more pieces about the killer than anyone else, and eventually became a target himself.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A few days before Halloween, 1970, after the known killings had stopped, the Zodiac decided to have some fun with his favorite reporter. He sent Avery a Halloween card. It had a cartoon skeleton on the front, with a preprinted message that—although not written by the Zodiac—was bizarre and threatening:")]), _vm._v(" "), _c('blockquote', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "blocklt"
  }, [_vm._v("I feel it in my bones,")]), _vm._v(" "), _c('p', {
    staticClass: "blocklt"
  }, [_vm._v("You ache to know my name,")]), _vm._v(" "), _c('p', {
    staticClass: "blocklt"
  }, [_vm._v("And so I’ll clue you in…")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On the inside, the message finished with, “But then, why spoil the game?”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-031",
      "id": "endnote-031-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" I really want to know who dropped acid and made this card.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("That wasn’t all. The Zodiac decided to show off his art skills by drawing pictures of elaborate, staring eyes and then another message reading: “Peekaboo, You are doomed.” He also wrote on the back of the card in columns: PARADICE [sic] SLAVES. "), _c('span', {
    attrs: {
      "aria-label": "page 19",
      "epub:type": "pagebreak",
      "id": "page_19",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Those words intersected into a cross and were circled by the words: BY FIRE BY GUN BY KNIFE BY ROPE."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-032",
      "id": "endnote-032-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You can buy a replica of the front of the card in sticker, postcard, or greeting card format on Redbubble for less than four dollars. I’ll let you judge whether that’s quirky or in the worst taste possible.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The whole thing must have given Avery and everyone in his circle a sense of dread. Investigators at the time said that they believed the card was intended as a death threat for Avery, and a handwriting expert later confirmed that the card came from the Zodiac, not a copycat. The Zodiac had also written the number fourteen or “4-teen” in a few places around the card. Investigators believed that either meant that the Zodiac was saying he had killed fourteen people…or that Avery would be his fourteenth victim. However, there were still only five victims officially attributed to the Zodiac. For reasons that escape me, Avery told reporters that he refused police protection.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“I do think I’ll be a little careful for a while,” Avery said. “I consider the ‘you are doomed’ to be a lot of talk.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-033",
      "id": "endnote-033-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Avery admitted to baiting the Zodiac in some of his work, but he was confident enough to say, “I’m not frightened, but I think Zodiac is.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-034",
      "id": "endnote-034-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" That’s a bold statement if ever there was one. But that was Avery’s style. He even went so far as to suggest the Zodiac was too scared after the murder of cabdriver Paul Stine. Avery said the Zodiac was almost caught, and since then, “has not identified anyone he has killed. He just boosts the number.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-035",
      "id": "endnote-035-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" It’s an interesting point. Who’s to say that after Stine the Zodiac didn’t stop killing? Maybe he just wanted to keep playing the game.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 20",
      "epub:type": "pagebreak",
      "id": "page_20",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("After the death threats were made public, male reporters wore buttons saying, “I’m not Paul Avery,” including Paul Avery himself."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-036",
      "id": "endnote-036-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" At least he had a sense of humor about the whole thing.")])]), _vm._v(" "), _c('hr', {
    staticClass: "secbreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Not long afterward, the Zodiac stopped killing in the Bay Area, leaving a cold trail of destruction and heartache in his wake. That never stopped the theories about who the Zodiac was from permeating the culture.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("For some reason, there are an incredible number of people out there convinced that their own relatives are the Zodiac. Some of them might want attention. It’s fair to say that a decent number of them have family dynamics that go beyond the term “dysfunctional.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("One example is Gary Stewart, from Baton Rouge, Louisiana. In 2014, the cleaning company vice president wrote a book about his biological father, Earl Van Best, Jr., titled "), _c('i', [_vm._v("The Most Dangerous Animal of All,")]), _vm._v(" written with journalist Susan Mustafa, which chronicles an adopted Stewart’s journey to find his biological dad, and coming up with a killer for a parent."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-037",
      "id": "endnote-037-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It was a "), _c('i', [_vm._v("New York Times")]), _vm._v(" best seller, coming out right as the true crime phenomenon was starting to hit its stride. That same year, "), _c('i', [_vm._v("This American Life’s")]), _vm._v(" podcast "), _c('i', [_vm._v("Serial")]), _vm._v(" was released, completely transforming podcasting and the true crime genre. Early the following year, HBO’s "), _c('i', [_vm._v("The Jinx")]), _vm._v(" came out, then Netflix’s "), _c('i', [_vm._v("Making a Murderer")]), _vm._v(". In January of 2016, "), _c('i', [_vm._v("My Favorite Murder")]), _vm._v(" released its first episode, and on and on the obsession grew. To come out with a staggering claim about a case that was known by even the most amateur true crime follower, right before some "), _c('span', {
    attrs: {
      "aria-label": "page 21",
      "epub:type": "pagebreak",
      "id": "page_21",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("of the most popular productions in true crime history would be released, is lightning you can’t catch in a bottle twice.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Stewart’s “evidence” that his now-deceased father was the Zodiac included some of his own DNA kinda, sorta, but not really matching DNA of the Zodiac retrieved from a stamp off one of his letters. It also included the unscrambling of a cipher to somehow read “EV Best,” and a fingerprint found at the Stine crime scene that may or may not belong to the Zodiac, and when reverse engineered, vaguely matched a print of Best. None of this is great, and "), _c('a', {
    attrs: {
      "href": "http://zodiackillerfacts.com",
      "target": "_blank"
    }
  }, [_vm._v("zodiackillerfacts.com")]), _vm._v(" really went to town debunking Stewart’s claims."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-038",
      "id": "endnote-038-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" But don’t feel too bad for Stewart, as of April 2019 he was—what else—working on a documentary about his dad as the Zodiac.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The man most people believe to have been the Zodiac is Arthur Leigh Allen, a former Vallejo schoolteacher and the only suspect to be served with search warrants by police. Allen was a prime suspect, even after his death in 1992. Vallejo police said they had Allen’s DNA in 2001 when they sent white envelopes to a lab for DNA analysis. However, police wouldn’t confirm if they were comparing it to the Zodiac, or if they had other DNA samples from suspects to test."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-039",
      "id": "endnote-039-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" This well came up dry.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("But while DNA didn’t give answers in 2001, there were still plenty who believed that Allen was the guy, most notably writer Robert Graysmith. His books "), _c('i', [_vm._v("Zodiac")]), _vm._v(" and "), _c('i', [_vm._v("Zodiac Unmasked")]), _vm._v(" were used to make David Fincher’s movie, "), _c('i', [_vm._v("Zodiac")]), _vm._v("—which also points the finger right at Allen. While there’s a lack of forensic evidence to link Allen to the Zodiac killings, Graysmith stands by his twenty-five years of research. That included Allen being one of nine people at Lake Berryessa the day Cecelia and "), _c('span', {
    attrs: {
      "aria-label": "page 22",
      "epub:type": "pagebreak",
      "id": "page_22",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Bryan were attacked. Allen is also said to have bragged to a coworker that he was going to kill couples at night, sent letters to the press, and called himself “Zodiac.” Graysmith points to that coworker, Don Cheney, taking and passing a lie detector test. I’m skeptical that someone as measured and controlled as the Zodiac would be able to go this long without being caught but would mouth off with specifics to a coworker.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Graysmith does admit that it’s impossible to know for sure if Allen is the right guy. In a 2007 interview with Rossiter Drake for the "), _c('i', [_vm._v("San Francisco Examiner")]), _vm._v(", Graysmith said, “The evidence is circumstantial, and you never know in this case. I do think to myself, ‘There were thousands of suspects, but what if there was one more?’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The option to test the “maybe there’s one more” theory seemed to reopen in 2018. After police were able to make an arrest in the Golden State Killer case based off of DNA, there was buzz about what major cold case could be next. Of course, speculation was high that it would be the Zodiac. In May of 2018, law enforcement sent out DNA for analysis again. But then, it was crickets. When I reached out to Vallejo police for an update, I received an email that said, “Unfortunately, at this time we do not have any updates to release on this case at this time. I hope you have a wonderful day.” I wonder how many times poor Sergeant Jeff Tai has had to email that statement.")]), _vm._v(" "), _c('hr', {
    staticClass: "secbreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Joan Didion had a hand in creating the modern Los Angeles—yet another California location of yet another infamous, though solved—murder spree. She said of the murders of Sharon Tate, Abigail Folger, Jay Sebring, Steven Parent, and Voytek "), _c('span', {
    attrs: {
      "aria-label": "page 23",
      "epub:type": "pagebreak",
      "id": "page_23",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Frykowski: “Many people I know in Los Angeles believe that the sixties ended abruptly on August 9, 1969.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-040",
      "id": "endnote-040-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" The murders by the “Family” of Charles Manson represented the end of the Swinging Sixties. The psychedelic, free love era in many ways did come to a hard stop on that smoldering hot August night. People started carrying handguns. The bright colors and acid trips grew muted. People stayed home. They reined themselves back in.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Society became more controlled.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Two months later, the Zodiac, completely outside of his normal methodology, committed the last murder that he would publicly take credit for: Paul Stine, the cabdriver. Some antics attributed to the Zodiac after that were very unlike him. It was as though as society became more measured and cautious, he began to lose control of his senses.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On October 22, 1969, a man called the Oakland Police Department claiming to be the Zodiac and saying he wanted to talk to an attorney—Melvin Belli would do."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-041",
      "id": "endnote-041-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" Belli was called the “King of Torts,” and throughout his career he had clients like the swashbuckling actor Errol Flynn and boxer Muhammad Ali. An interview was arranged, and the conversation was broadcast on live television, even though the police believed it was a hoax. The guy on the other end of the line called himself “Sam” and complained of headaches. At one point he screamed. It made for riveting TV but brought police no closer to catching the Zodiac. The call was traced to a mental patient at a hospital, but law enforcement and society had shown the Zodiac that they were still under his complete control.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 24",
      "epub:type": "pagebreak",
      "id": "page_24",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Then in December of 1969, Belli got a letter. The letter was sad, begging for help to not kill any more people. It ended, “Please help me I can not [sic] remain in control for much longer.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-042",
      "id": "endnote-042-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There are two possibilities with this letter.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("One possibility is it’s a fake. Though the handwriting was quite similar to previous letters from the Zodiac and included misspelled words, this is very possible.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The other possibility is it was the Zodiac. I lean toward this theory. If it was the killer, he was taking the piss out of Belli after the talk show incident. Nothing up until this point says that the Zodiac is anything other than fully capable, conscious, in control, and loving it. The way he slowly savored every moment of his kills, the careful, measured way that he planned them all, says that this was a game for him. A game he treasured, and something he wanted to keep doing.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In his book, "), _c('i', [_vm._v("The Cases That Haunt Us")]), _vm._v(", FBI criminal profiler John Douglas said he thought the Zodiac got scared on the night he killed cabdriver Paul Stine. Not only did several witnesses see the Zodiac leave the scene, he potentially spoke to two police officers as he was leaving the scene. But because it was dark and they’d initially been told to look for a black man, the officers let him go. According to Douglas, after the Stine murder, the Zodiac “saw the writing on the wall.”")]), _vm._v(" "), _c('blockquote', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "blockl"
  }, [_vm._v("Offenders like this don’t go down easy. To lose the high of being the lead story on the news for years, on and off, of having so many people fear you, to surrender all power and control and go to prison, that’s when I advise a round-the-clock suicide watch."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-043",
      "id": "endnote-043-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 25",
      "epub:type": "pagebreak",
      "id": "page_25",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Serial killers stop their “work” for multiple reasons. Some are arrested on other charges. If arrested, sometimes they’re released and kill again, but maybe in a different way, or they die in prison. According to Peter Vronsky’s book, "), _c('i', [_vm._v("Serial Killers: The Method and Madness of Monsters,")]), _vm._v(" there actually is such a thing as serial killer burnout. When that happens, perhaps due to lack of attention or interest in killing, some will turn themselves in. Others will commit suicide, and in rare cases, some might just fade into the background and stop killing all on their own."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-044",
      "id": "endnote-044-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It’s impossible to know which, if any, of these situations applied to the Zodiac. What we do know is that he did stop killing, although he kept trying to maintain the spotlight.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Intermittently, the Zodiac kept sending letters to newspapers, trying to keep his name in the headlines. He kept upping his alleged kill tally in these letters, but I think it was all a bluff. Police could never confirm any of these kills. The closest anyone has gotten is a reference to “…the woeman [sic] and her baby that I gave a rather interesting ride for a coupple howers [sic]” from a summer of 1970 letter to the "), _c('i', [_vm._v("San Francisco Chronicle")]), _vm._v("."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-045",
      "id": "endnote-045-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Many believe this is in reference to twenty-two-year-old Kathleen Johns. On March 20, 1970, she was driving with her baby daughter on the highway when a vehicle pulled up next to her and tried to get her to pull over. She did, and the driver told Kathleen the back wheel of her car was loose. When he went to fix it, he loosened the wheels for real, and one fell off before she could get anywhere. The driver offered to take Kathleen and her kid to the gas station, and she accepted.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 26",
      "epub:type": "pagebreak",
      "id": "page_26",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("The drive got weird quickly for Kathleen; she said he made some vague threats to her and her daughter. So she grabbed her kid and jumped out of the car. Then she promptly got into the car of another person driving by. Luckily this was an upstanding citizen who took her to a police station, where, when Kathleen saw the Zodiac sketch, she said it was the same man."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-046",
      "id": "endnote-046-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I think this was the last time the Zodiac attempted anything. He had worked up some courage, or felt the need to try something new, and he went for it and failed. After that, he just couldn’t risk it again. He’d lost his ability to control every situation, and he wasn’t good at improvising. So instead he wrote letters, tried to take credit for things he likely didn’t do, until eventually he faded away. After a couple letters in 1971, nothing was heard from the Zodiac for three years.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In January of 1974, he sent the "), _c('i', [_vm._v("San Francisco Chronicle")]), _vm._v(" a letter saying that the movie "), _c('i', [_vm._v("The Exorcist")]), _vm._v(" was “the best staerical [sic] comidy that I have ever seen.” Now he claimed to have killed thirty-seven people. He sent a couple more letters, then radio silence until April of 1978. Douglas believes this final communication “reads like a suicide note.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781646041145/xhtml/endnotes#endnote-047",
      "id": "endnote-047-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "blocklt"
  }, [_vm._v("Dear Editor")]), _vm._v(" "), _c('p', {
    staticClass: "blocklt"
  }, [_vm._v("This is the Zodiac speaking I")]), _vm._v(" "), _c('p', {
    staticClass: "blocklt"
  }, [_vm._v("am back with you. Tell herb caen")]), _vm._v(" "), _c('p', {
    staticClass: "blocklt"
  }, [_vm._v("I am here, I hae [sic] always been here.")]), _vm._v(" "), _c('p', {
    staticClass: "blocklt"
  }, [_vm._v("That city pig toschi is good but")]), _vm._v(" "), _c('p', {
    staticClass: "blocklt"
  }, [_vm._v("I am [crossed out letters] smarter and better he")]), _vm._v(" "), _c('p', {
    staticClass: "blocklt"
  }, [_vm._v("will get tired then leave me")]), _vm._v(" "), _c('p', {
    staticClass: "blocklt"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 27",
      "epub:type": "pagebreak",
      "id": "page_27",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("alone. I am waiting for a good")])]), _vm._v(" "), _c('p', {
    staticClass: "blocklt"
  }, [_vm._v("movie about me. Who will play")]), _vm._v(" "), _c('p', {
    staticClass: "blocklt"
  }, [_vm._v("me. I am now in control of all")]), _vm._v(" "), _c('p', {
    staticClass: "blocklt"
  }, [_vm._v("things.")]), _vm._v(" "), _c('p', {
    staticClass: "blocklt"
  }, [_vm._v("Yours truly:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Where there would have been a signature, there was a new murder tally: “Zodiac—guess, SFPD zero.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Zodiac was done. Maybe he did in fact kill himself as Douglas suggested, or maybe he was dying from something else. Whatever it was, this shell of a being, who had terrorized a hunting ground of his own creation for so long, was now too afraid to do anything besides blow smoke. And he knew it.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("At the end of it all, this control freak was a coward.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ec4c0fb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781646041145/xhtml/ch01.vue
// module id = 66
// module chunks = 0